import script from "./AllPriceDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllPriceDetail.vue?vue&type=script&lang=ts&setup=true"

import "./AllPriceDetail.vue?vue&type=style&index=0&id=f136f358&lang=scss"

const __exports__ = script;

export default __exports__